<template>
  <div>  
    <b-navbar toggleable="lg" type="dark" fixed class="navbar">
      <b-navbar-brand @click="redirect('/')">
        <img src="@/assets/picz_logo_blue_small.svg" height="80" alt="Logo">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    </b-navbar> 

  </div>
</template>
<script>
  import 'bootstrap/dist/css/bootstrap.css';
  import 'bootstrap-vue/dist/bootstrap-vue.css';

  export default {
    name: "NavBar-2",
    methods:{
      redirect(path){
        this.$router.push(path);
      },
    }
  }
</script>
<style scoped>
  .navbar {
    height: 100px;
    width: 100%;
    background-color: whitesmoke;
    border-bottom: 1px solid #ccc;
    color: white;
    padding-left: 20px;
  }
</style>
